var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Toolbar'),_c('Carousel'),_c('Welcome'),_c('Features'),_c('OtherPlatforms'),_c('OneStep'),_c('HomeGuide'),_c('FooterBar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }